'use strict';

/**
 * View for rendering the selection of a location in modal update/select location
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var SelectMetaStoragesItemView = require('./select-meta-storages-item');

var template = require('../../templates/partials/select-meta-storages-list.hbs');

var SelectMetaStoragesListView = ColidoCompositeView.extend({
    template: template,

    childView: SelectMetaStoragesItemView,

    childViewContainer: '.list',
});

module.exports = SelectMetaStoragesListView;